import React, { useEffect, useState, } from 'react';
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import axios from 'axios';

import {
    buttonProcessGet, responseGet, globalSettings, setBadgeStatusGeneric, numberSet, styles, validateDecimals, dateTimeFormatGlobalSet, sendMessageCloseCurrentWindowAsync,
    separatorsNumbersSet, languageObjGet, isUndNullEmp, awaitDelay,
} from '../../helpers/settings';
import moment from 'moment-timezone';
import { buildingModelGet } from '../../models/buildings/building';
import { bankAccountModelGet } from '../../models/bankAccounts/bankAccount';
import { coinModelGet } from '../../models/coins/coin';
import { bankModelGet } from '../../models/banks/bank';
import { GlobalFormats } from '../../classes/main/globalFormats';

const { backend, } = globalSettings?.app;
const { icons, labels, messages, bankAccount: bankAccountObj, } = globalSettings;
const { properties: dbProps, } = globalSettings?.collections;
const { html, tempusDominus, } = globalSettings?.react;

const neutralValue = 0.00;
const currentMethod = 'BankAccountAddEditDetails';

export default function BankAccountAddEditDetails({
    $ = {},
    auth = {},
    building = buildingModelGet({}),
    buildingBalanceGetAsync = async ({
        bankAccounts = [],
        buildingId = '',
        subMethod = '',
    }) => { },
    bankAccount = bankAccountModelGet({}),
    setBankAccount = () => { },
    coins = [coinModelGet({})],
    banks = [bankModelGet({})],
    dtBankAccountsId = '',
    dtRowIndex = 0,
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),

}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const bankAccountDateId = 'bankAccountDate';
    const [numberError, setNumberError] = useState('');
    const [dateError, setDateError] = useState('');
    const [coinError, setCoinError] = useState('');
    const [bankError, setBankError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [initialBalanceError, setInitialBalanceError] = useState('');
    const [currentBalanceError, setCurrentBalanceError] = useState('');
    const [bankAccountBefore, setBankAccountBefore] = useState({});
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnBankAccountModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnBankAccountModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnBankAccountModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            inactive: {
                id: 'chkBankAccountModalEnable',
                className: 'icheck-primary d-inline',
            },
            inactiveReadOnly: {
                id: 'chkBankAccountModalReadOnly',
                className: 'icheck-primary d-inline',
            },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtBankAccountesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtBankAccountesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtBankAccountesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtBankAccountesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtBankAccountesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtBankAccountesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtBankAccountesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtBankAccountesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoBankAccountModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoBankAccountModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoBankAccountModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            number: {
                id: 'inputBankAccountModalNumber',
                className: 'form-control',
            },
            date: {
                id: 'inputBankAccountModalDate',
                className: 'form-control datetimepicker-input',
            },
            initialBalance: {
                id: 'inputBankAccountModalInitialBalance',
                className: 'form-control text-right',
            },
            currentBalance: {
                id: 'inputBankAccountModalCurrentBalance',
                className: 'form-control text-right',
            },
        },
        selects: {
            banks: {
                id: 'selBankAccountModalBanks',
                className: 'form-select',
            },
            types: {
                id: 'selBankAccountModalTypes',
                className: 'form-select',
            },
            coins: {
                id: 'selBankAccountModalCoins',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spBankAccountModalSave',
                className: '',
            },
            back: {
                id: 'spBankAccountModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region bankAccount (metods)
    const bankAccountAddPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRows = [];
            //let processButtonsLocal = [];
            let bankAccountLocal = bankAccountModelGet({});
            //#endregion variables

            //#region initialize
            response = await errorDefaultSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region dataSetAsync
            response = await dataSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dataSetAsync

            //#region validateFormDataAsync
            response = await validateFormDataAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion validateFormDataAsync

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create bank account
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                bankAccount: bankAccount,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            bankAccountLocal = response?.result?.bankAccount || {};
            setBankAccount(bankAccountLocal);
            //#endregion create bank account

            //#region dtBankAccountes record add
            //#region variables
            dataObj = {
                description: banks?.find(({ id }) => id === bankAccountLocal?.bankId)?.description || '',
                number: bankAccountLocal?.number || {},
                type: bankAccountLocal?.type === 'S' ?
                    labels?.savings?.[languageObj?.id] :
                    bankAccountLocal.type === 'C' ?
                        labels?.current?.[languageObj?.id] :
                        '',
                status: setBadgeStatusGeneric({
                    type: bankAccountLocal?.inactive ?
                        1 :
                        0,
                    value: bankAccountLocal?.inactive ?
                        labels?.inactive?.[languageObj?.id] :
                        labels?.active?.[languageObj?.id],
                    subMethod: currentMethod,
                }),
                currentBalance: separatorsNumbersSet({
                    number: bankAccountLocal?.currentBalance,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                processButtons: [
                    {
                        isVisible: true,
                        showDivider: false,
                        label: labels?.movements?.[languageObj?.id],
                        isEnabled: true,
                        methodName: backend?.methods?.movements,
                        icon: icons?.chartLine,
                    },
                    {
                        isVisible: true,
                        showDivider: true,
                        label: labels?.delete?.[languageObj?.id],
                        isEnabled: true,
                        methodName: backend?.methods?.delete,
                        icon: icons?.trash,
                    },
                ],
            };
            //#endregion variables

            //#region methods
            dtRows = [
                dataObj?.description,
                dataObj?.number,
                dataObj?.type,
                dataObj?.status,
                dataObj?.currentBalance,
                buttonProcessGet({
                    id: bankAccountLocal?.id,
                    description: dataObj?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: false,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: dataObj?.processButtons,
                    subMethod: currentMethod,
                })?.result,
            ];
            //#endregion methods

            $(`#${dtBankAccountsId}`)?.DataTable()?.row?.add(dtRows)?.draw(true);
            //#endregion dtBankAccountes record add

            //#regionbuilding balance calculate
            response = await buildingBalanceGetAsync({
                bankAccounts: [],
                buildingId: bankAccountLocal?.buildingId,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregionbuilding balance calculate

            //#region default set
            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });
            //#endregion default set

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const bankAccountEditPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRows = [];
            let bankAccountLocal = bankAccountModelGet({});
            //#endregion variables

            //#region initialize
            response = await errorDefaultSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region dataSetAsync
            response = await dataSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dataSetAsync

            //#region validateFormDataAsync
            response = await validateFormDataAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion validateFormDataAsync

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region bankAccount update
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                bankAccount: bankAccount,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/${bankAccount?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            bankAccountLocal = response?.result?.bankAccount || {};
            setBankAccount(bankAccountLocal);
            //#endregion bankAccount update

            //#region dtBankAccountes record add
            //#region variables
            dataObj = {
                description: banks?.find(({ id }) => id === bankAccountLocal?.bankId)?.description || '',
                number: bankAccountLocal?.number || {},
                type: bankAccountLocal?.type === 'S' ?
                    labels?.savings?.[languageObj?.id] :
                    bankAccountLocal.type === 'C' ?
                        labels?.current?.[languageObj?.id] :
                        '',
                status: setBadgeStatusGeneric({
                    type: bankAccountLocal?.inactive ?
                        1 :
                        0,
                    value: bankAccountLocal?.inactive ?
                        labels?.inactive?.[languageObj?.id] :
                        labels?.active?.[languageObj?.id],
                    subMethod: currentMethod,
                }),
                currentBalance: separatorsNumbersSet({
                    number: bankAccountLocal?.currentBalance,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                processButtons: [
                    {
                        isVisible: true,
                        showDivider: false,
                        label: labels?.movements?.[languageObj?.id],
                        isEnabled: true,
                        methodName: backend?.methods?.movements,
                        icon: icons?.chartLine,
                    },
                    {
                        isVisible: true,
                        showDivider: true,
                        label: labels?.delete?.[languageObj?.id],
                        isEnabled: true,
                        methodName: backend?.methods?.delete,
                        icon: icons?.trash,
                    },
                ],
            };
            //#endregion variables

            //#region methods
            dtRows = [
                dataObj?.description,
                dataObj?.number,
                dataObj?.type,
                dataObj?.status,
                dataObj?.currentBalance,
                buttonProcessGet({
                    id: bankAccountLocal?.id,
                    description: dataObj?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: false,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: dataObj?.processButtons,
                    subMethod: currentMethod,
                })?.result,
            ];
            //#endregion methods

            $(`#${dtBankAccountsId}`)?.DataTable()?.row(dtRowIndex).data(dtRows)?.draw(true);
            //#endregion dtBankAccountes record add

            //#regionbuilding balance calculate
            response = await buildingBalanceGetAsync({
                bankAccounts: [],
                buildingId: bankAccountLocal?.buildingId,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregionbuilding balance calculate

            //#region data set
            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });
            //#endregion data set

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion bankAccount (metods)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            response = await dateInControlSetAsync({
                date: new Date(),
                bankAccountDate: bankAccount.date,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            setBankAccountBefore(bankAccount);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSetAsync = async ({
        date = new Date(),
        bankAccountDate = undefined,
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.date = '';
            //const dateTimeObj?.format = tempusDominus?.format?.date?.DDMMYYYY;
            //const dateTimeObj?.format = tempusDominus?.format?.date?.dmy;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: bankAccountDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: bankAccountDate,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: tempusDominus?.icons,
                buttons: tempusDominus?.buttons,
                tooltips: tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            $(`#${bankAccountDateId}`).datetimepicker('options', {
                date: moment(dateTimeObj?.date, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errorDefaultSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'errorDefaultSetAsync';
        let response = responseGet();
        try {
            setDateError('');
            setCoinError('');
            setBankError('');
            setTypeError('');
            setNumberError('');
            setInitialBalanceError('');
            setCurrentBalanceError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataSetAsync = async ({
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: $(`#${bankAccountDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            bankAccount.date = dateTimeObj?.date || bankAccount?.date;
            bankAccount.initialBalance = numberSet({
                number: bankAccount?.initialBalance || neutralValue,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            bankAccount.currentBalance = numberSet({
                number: bankAccount?.currentBalance || neutralValue,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            if (processType === 0) {
                bankAccount.currentBalance = bankAccount?.initialBalance || neutralValue;
            } else {
                if (bankAccount?.initialBalance !== bankAccountBefore?.initialBalance) {
                    bankAccount.currentBalance = ((bankAccount?.currentBalance - bankAccountBefore?.initialBalance) + bankAccount?.initialBalance);
                    if (bankAccount?.initialBalance !== 0 && bankAccount?.currentBalance === 0) {
                        bankAccount.currentBalance = bankAccount?.initialBalance;
                    }
                }
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const validateFormDataAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: $(`#${controls?.inputs?.date?.id}`)?.val(),
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: bankAccount?.number, subMethod: currentMethod, })?.result) {
                setNumberError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: bankAccount?.bankId, subMethod: currentMethod, })?.result) {
                setBankError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: bankAccount?.type, subMethod: currentMethod, })?.result) {
                setTypeError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dateTimeObj?.date, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: bankAccount?.date, subMethod: currentMethod, })?.result) {
                setDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: bankAccount?.coinId, subMethod: currentMethod, })?.result) {
                setCoinError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.number?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.selects?.banks?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.selects?.types?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.date?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.selects?.coins?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.initialBalance?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.currentBalance?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - on load',
        });
    }, [showModal]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <Modal backdrop='static'
            show={showModal}
            onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.bankAccount?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.bankAccountLogo}></img> - {labels?.bankAccount?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    //className='close btn-danger fas fa-window-close'
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ?
                bankAccountAddPostAsync({ e: e, subMethod: 'btn - bankAccountAdd', }) :
                processType === 1 ?
                    bankAccountEditPostAsync({ e: e, subMethod: 'btn - bankAccountUpdate', }) :
                    e?.preventDefault()}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => processType === 0 ? bankAccountAddPostAsync(e) : (processType === 1 ? bankAccountEditPostAsync(e) : e?.preventDefault())}> */}
                    {/* <div className='card card-primary card-outline shadow-lg'> */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.bankAccount?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.bankAccountLogo}></img> - {labels?.bankAccount?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* <div className='card-body'> */}
                    {processType !== 2 ?
                        <div>
                            <div className='row '>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.number?.id}
                                                className={controls?.inputs?.number?.className}
                                                //autoFocus
                                                onChange={(e) => setBankAccount({
                                                    ...bankAccount,
                                                    [dbProps?.number]: e?.target?.value,
                                                })}
                                                onFocus={() => setNumberError('')}
                                                placeholder={labels?.number?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.number?.[languageObj?.id]}
                                                value={bankAccount?.number || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.sortNumericUpAlt} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(numberError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.banks?.id}
                                                className={controls?.selects?.banks?.className}
                                                defaultValue={bankAccount?.bankId}
                                                onChange={(e) => setBankAccount({
                                                    ...bankAccount,
                                                    [dbProps?.bankId]: e?.target?.value,
                                                })}
                                                onFocus={() => setBankError('')}
                                                placeholder={labels?.bank?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.bank?.[languageObj?.id]}>
                                                <option key='nothing' value=''>{messages?.selectBank?.[languageObj?.id]}</option>
                                                {banks?.map((bank) => <option key={bank?.id} value={bank?.id}>{bank?.description}</option>)}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.university} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(bankError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row '>
                                <div className='col-md-8'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.types?.id}
                                                className={controls?.selects?.types?.className}
                                                defaultValue={bankAccount.type}
                                                onChange={(e) => setBankAccount({
                                                    ...bankAccount,
                                                    [dbProps?.type]: e?.target?.value,
                                                })}
                                                onFocus={() => setTypeError('')}
                                                placeholder={labels?.type?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.type?.[languageObj?.id]}>
                                                <option key='nothing' value=''>{messages?.selectType?.[languageObj?.id]}</option>
                                                {/* <option key='C' value='C'>{labels?.current?.[languageObj?.id]}</option>
                                                <option key='S' value='S'>{labels?.savings?.[languageObj?.id]}</option> */}
                                                {
                                                    bankAccountObj?.types?.map((detail) =>
                                                        (<option key={detail?.id} value={detail?.id}>{detail?.description?.[languageObj?.id]}</option>))
                                                }
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.piggyBank} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(typeError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='form-group'>
                                        <div className='input-group'>
                                            <div className={controls?.checkBox?.inactive?.className}>
                                                <input id={controls?.checkBox?.inactive?.id}
                                                    checked={bankAccount?.inactive || false}
                                                    onChange={(e) => setBankAccount({
                                                        ...bankAccount,
                                                        [dbProps?.inactive]: e?.target?.checked,
                                                    })}
                                                    tooltip='tooltip'
                                                    title={labels?.condition?.[languageObj?.id]}
                                                    type='checkbox' />
                                                <label className='text-muted'
                                                    htmlFor={controls?.checkBox?.inactive?.id}
                                                    tooltip='tooltip'
                                                    title={labels?.condition?.[languageObj?.id]}> {labels?.inactive?.[languageObj?.id]}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <div id={bankAccountDateId} className='input-group date' data-target-input='nearest'>
                                                <input id={controls?.inputs?.date?.id}
                                                    className={controls?.inputs?.date?.className}
                                                    data-target={`#${bankAccountDateId}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setDateError('')}
                                                    placeholder={labels?.date?.[languageObj?.id]}
                                                    tooltip='tooltip'
                                                    title={labels?.date?.[languageObj?.id]}
                                                    type='text' />

                                                <div className='input-group-append'
                                                    data-target={`#${bankAccountDateId}`}
                                                    data-toggle='datetimepicker'>
                                                    <div className='input-group-text'>
                                                        <i className={icons?.calendarAlt}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.coins?.id}
                                                className={controls?.selects?.coins?.className}
                                                defaultValue={bankAccount.coinId}
                                                onChange={(e) => setBankAccount({
                                                    ...bankAccount,
                                                    [dbProps?.coinId]: e?.target?.value,
                                                })}
                                                onFocus={() => setCoinError('')}
                                                placeholder={labels?.coin?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.coin?.[languageObj?.id]}>
                                                <option value=''>{messages?.selectCoin?.[languageObj?.id]}</option>
                                                {
                                                    coins?.map((coin) => (<option key={coin?.id} value={coin?.id}>{coin?.description}</option>))
                                                }
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-coins' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(coinError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4 text-muted'>
                                    {labels?.balance?.[languageObj?.id]}
                                </div>
                                <div className='col-md-8'>
                                    <hr />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.initialBalance?.id}
                                                className={controls?.inputs?.initialBalance?.className}
                                                onChange={(e) => setBankAccount({
                                                    ...bankAccount,
                                                    [dbProps?.initialBalance]: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - initialBalance', })
                                                })}
                                                onFocus={() => setInitialBalanceError('')}
                                                placeholder={labels?.initialBalance?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.initialBalance?.[languageObj?.id]}
                                                value={bankAccount?.initialBalance || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(initialBalanceError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.currentBalance?.id}
                                                className={controls?.inputs?.currentBalance?.className}
                                                onChange={(e) => setBankAccount({
                                                    ...bankAccount,
                                                    [dbProps?.currentBalance]: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - currentBalance', })
                                                })}
                                                onFocus={() => setCurrentBalanceError('')}
                                                placeholder={labels?.currentBalance?.[languageObj?.id]}
                                                readOnly
                                                tooltip='tooltip'
                                                title={labels?.currentBalance?.[languageObj?.id]}
                                                value={bankAccount?.currentBalance || 0.00} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(currentBalanceError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.number?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <b>{bankAccount?.number || ''} </b>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.bank?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <b>{banks?.find(({ id }) => id === bankAccount?.bankId)?.description || ''} </b>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.type?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <b>{
                                            bankAccount?.type === 'S' ?
                                                labels?.savings?.[languageObj?.id] :
                                                bankAccount?.type === 'C' ?
                                                    labels?.current?.[languageObj?.id] :
                                                    ''
                                        } </b>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.inactive?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className={controls?.checkBox?.inactiveReadOnly?.className}>
                                        <input id={controls?.checkBox?.inactiveReadOnly?.id}
                                            checked={bankAccount?.inactive || false}
                                            readOnly
                                            type='checkbox' />
                                        <label htmlFor={controls?.checkBox?.inactiveReadOnly?.id}></label>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.date?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <b>{
                                            dateTimeFormatGlobalSet({
                                                date: bankAccount?.date,
                                                type: languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: false,
                                                secondsShow: false,
                                                languageId: languageObj?.id,
                                                subMethod: currentMethod,
                                            })?.result
                                        } </b>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.coin?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <b>{coins?.find(({ id }) => id === bankAccount?.coinId)?.description || ''} </b>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.balance?.[languageObj?.id]}</b>
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <hr />
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.initialBalance?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <b>{
                                            separatorsNumbersSet({
                                                number: bankAccount?.initialBalance,
                                                withDecimals: true,
                                                consoleLogErrorShow: true,
                                                subMethod: 'input - initialBalance',
                                            })?.result
                                        }</b>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.currentBalance?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <b>{
                                            separatorsNumbersSet({
                                                number: bankAccount?.currentBalance,
                                                withDecimals: true,
                                                consoleLogErrorShow: true,
                                                subMethod: 'input - initialBalance',
                                            })?.result
                                        }</b>
                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                    {/* </div> */}
                    {/* </div> */}

                    {/* <div className='form-group text-right'>
                        <button className='btn btn-outline-warning'
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i className={icons?.save}></i>
                        </button>
                        <button className='btn btn-outline-success mx-1'
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync(true)}>
                            <i className={icons?.arrowCircleLeft}></i>
                        </button>
                    </div> */}
                    {/* </form> */}
                </Modal.Body>
                <Modal.Footer>
                    <button id={controls?.buttons?.save?.id}
                        className={controls?.buttons?.save?.className}
                        hidden={processType === 2}
                        tooltip='tooltip'
                        title={labels?.save?.[languageObj?.id]}
                        type='submit'>
                        <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                    </button>
                    <button id={controls?.buttons?.back?.id}
                        className={controls?.buttons?.back?.className}
                        tooltip='tooltip'
                        title={labels?.close?.[languageObj?.id]}
                        type='button'
                        onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}